export default __webpack_public_path__ + "static/media/edit_disabled.8776c2b1.svg";